import { theme } from 'styles/theme';

export const PLACEHOLDER_BACKGROUND_COLORS = [
  theme.colors?.utility['purple-1'],
  theme.colors?.utility['orange-1'],
  theme.colors?.utility['teal-1'],
];
